import { ResolverTag } from '@ps/web-core-enums';
import {
  CrossIcon,
  StarsButton,
  Translation,
  useNavigate,
  useResolver
} from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import LoadingIndicatior from '@swf/components/LoadingIndicator/LoadingIndicator';
import { Vary } from '@swf/components/ResponseHeaders/ResponseHeaders';
import StarsModal from '@swf/components/StarsModal/StarsModal';
import { Header } from '@swf/core/enums';
import { select } from '@swf/core/store';
import { fetchJson } from '@swf/core/utils/api';

import LoginForm from '../LoginForm/LoginForm';

import {
  TXTCLI_Close,
  TXTCLI_Please_try_again_laterX,
  TXTCLI_UnfortunatelyX_your_request_co_ELL,
  TXTWCL_Log_in_to_access_XXBrandXX_Com_ELL
} from './CommunityForumLogin.messages.json';
import styles from './CommunityForumLogin.scss';
import CommunityForumWatermarkIcon from './assets/community-forum-watermark.svg';
import CommunityForumIcon from './assets/community-forum.svg';

const CommunityForumLogin: React.FC = () => {
  const history = useHistory();
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const communityForumBaseURL = useResolver(ResolverTag.CommunityForumBaseURL);

  useEffect(() => {
    if (isAuthenticated && communityForumBaseURL) {
      fetchJson('/api/v1-preview/auth/community', {
        credentials: 'include'
      })
        .then(({ token }) => {
          navigate('/');
          window.open(`${communityForumBaseURL}${token}`, '_blank');
        })
        .catch(() => setError(true));
    }
  }, [navigate, isAuthenticated, communityForumBaseURL]);

  const handleClose = () => history.goBack();

  return (
    <>
      <Vary by={[Header.Auth]} />
      <StarsModal />
      <div className={styles.container}>
        <div className={styles.header}>
          <CommunityForumIcon />
          <StarsButton
            onClick={handleClose}
            className={styles.closeIcon}
            icon={<CrossIcon />}
            data-testid="closeButton"
          />
        </div>
        <section className={classNames(styles.section, { [styles.error]: error })}>
          {error ? (
            <>
              <div>
                <Translation tagName="p" {...TXTCLI_UnfortunatelyX_your_request_co_ELL} />
                <Translation tagName="p" {...TXTCLI_Please_try_again_laterX} />
              </div>
              <StarsButton translation={TXTCLI_Close} onClick={handleClose} />
            </>
          ) : (
            <LoadingIndicatior loading={isAuthenticated} className={styles.loading}>
              <Translation
                tagName="h3"
                values={{ brand: 'PokerStars' }}
                {...TXTWCL_Log_in_to_access_XXBrandXX_Com_ELL}
              />
              <hr />
              <div className={styles.loginForm}>
                <LoginForm isCommunity />
              </div>
            </LoadingIndicatior>
          )}
        </section>
        <div className={styles.footer}>
          <CommunityForumWatermarkIcon />
        </div>
      </div>
    </>
  );
};

export default CommunityForumLogin;
